import { render, staticRenderFns } from "./VacationRequestDetail.vue?vue&type=template&id=237845b9"
import script from "./VacationRequestDetail.vue?vue&type=script&lang=js"
export * from "./VacationRequestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports